var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSettingsSection',{attrs:{"title":_vm.t('activity', 'Default settings'),"description":_vm.t('activity', 'Configure the default notification settings for new users.')}},[_c('ActivityGrid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }